import React, { ReactElement, FunctionComponent } from 'react'
import { TextAlignTypes, TextColorTypes } from '../FontTypes'
import BasicText, { WebHeadlineType } from '../BasicText'
import { TestID } from '../../../utils/PropTypesDefinitions'

export type NavigationTitleProps = WebHeadlineType & {
    children: string
    textAlign?: TextAlignTypes
    numberOfLines?: number
    color?: TextColorTypes
    fontSize?: 'FS16' | 'FS18'
} & TestID

const NavigationTitle: FunctionComponent<NavigationTitleProps> = ({
    children,
    textAlign,
    numberOfLines = 1,
    color = 'WHITE',
    webHeadlineType,
    fontSize = 'FS16',
    testID,
}): ReactElement => {
    return (
        <BasicText
            color={color}
            fontSize={fontSize}
            lineHeight="19px"
            textAlign={textAlign}
            bold
            numberOfLines={numberOfLines}
            webHeadlineType={webHeadlineType}
            testID={testID}
        >
            {children}
        </BasicText>
    )
}

export default NavigationTitle
